import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/reservation-request-new-action-types';

import type {List} from 'immutable';

export type ReservationRequestNewStore = {
    simulatorCompanies: List<unknown>;
};

const initialState = () => {
    return {
        simulatorCompanies: Immutable.List(),
    };
};

const actionsMap = {
    [actionTypes.GET_SIMULATORS_COMPANIES_SUCCESS]: (state, action) => {
        let simulatorCompanies = action.data;
        simulatorCompanies = simulatorCompanies.sort((a, b) => {
            a = a.get('simulatorCompanySort');
            b = b.get('simulatorCompanySort');
            if (a < b) {
                return -1;
            } else if (a > b) {
                return 1;
            } else {
                // a === b
                return 0;
            }
        });

        return {
            simulatorCompanies,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ReservationRequestNewStore>(initialState(), actionsMap);
